/*
 * Created on Tue March 8 2021
 * Author: Val Liu
 * Copyright (c) 2021
 */

import { Vue } from "vue-property-decorator";
import Server from "@/config/default/server";
import { BehaviorSubject } from "rxjs";
import data from "@/package.json";
import { publish } from "rxjs/internal/operators/publish";
import { refCount } from "rxjs/internal/operators/refCount";
import { concatMap, share } from "rxjs/operators";
import { Mutex } from "@/../core/server/utility/mutex";

declare module "vue/types/vue" {
    export interface Vue {
        $info: IInfo;
    }
}

interface IInfoServer {
    name: string | null;
    version: string | null;
    description: string | null;
    copyright: string | null;
}

interface IInfoWeb {
    name: string;
    version: string;
    description: string | null;
    copyright: string | null;
}

interface IInfo {
    env: "development" | "production";
    server?: IInfoServer;
    web?: IInfoWeb;
}

const info: IInfo = {
    env: process.env.NODE_ENV === "production" ? "production" : "development",
    server: {
        name: null,
        version: null,
        copyright: null,
        description: null,
    },
    web: {
        name: data.name,
        version: data.version,
        copyright: data.copyright,
        description: data.description,
    },
};
const mtxInfo: Mutex = new Mutex();
const sjInfo: BehaviorSubject<IInfo> = new BehaviorSubject<IInfo>(info);
let done = false;

export const InfoPlugin = {
    install: function (Vue: any) {
        if (Vue._val_info_installed) return;
        Vue._val_info_installed = true;

        Vue.mixin({
            subscriptions: () => {
                return {
                    $info: sjInfo,
                };
            },

            async created() {
                try {
                    await mtxInfo.acquire();
                    if (done) return;
                    done = true;
                    let info = sjInfo.getValue();
                    if (info.server?.version) return;

                    /// initial request to /apis, for server basic info
                    let apis = await this.$server.R("/auth/apis");
                    const { name, version, copyright, description } = apis.serverInfo;
                    sjInfo.next({
                        ...info,
                        server: { name, version, copyright, description },
                    });
                } catch (e) {
                    console.error("error on create <InfoPlugin>.", e);
                } finally {
                    mtxInfo.release();
                }
            },
        });
    },
};
